import{ Directive, HostListener, HostBinding } from '@angular/core'

@Directive({
    selector:'[appDetail]'
})

export class documentDetailDirective{

    showDocDetail = false;

    @HostBinding('class.open') isOpen = false;

    @HostListener('click') toggleOpen(){
        this.showDocDetail = true;
      //  alert('hello')
        this.isOpen = !this.isOpen 
    }
}
